import { PayloadAction } from '@reduxjs/toolkit';

import { IState } from '../types/state';

const action = (
  state: IState,
  payloadAction: PayloadAction<{ id: number; normalizedFilter: any }>,
) => {
  const { id, normalizedFilter } = payloadAction.payload;

  state.savedFilters.data = {
    ...state.savedFilters.data,
    [id]: {
      ...state.savedFilters.data[id],
      normalizedFilter,
    },
  };
};

export default action;
